import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import { FormattedMessage, } from "react-intl";
import SeoHeaders from "../components/SeoHeaders";
import * as wConsts from "../consts/website-consts";

class Terms extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "terms" });

  }

  render() {
    return (
      <div className="container default-content">
        <div className="row">
          <div className="col-sm-12">
          <pre style={{fontSize: '14px', lineHeight: '14px', whiteSpace: "pre-line", padding: "50px"}} dangerouslySetInnerHTML={{__html: this.props.MainContent}}></pre>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Terms);
